import { Theme } from "../../../types";
import { CSSObject } from "@emotion/react";

export const dropdownStyles = (
  theme: Theme
): { [key: string]: Record<string, CSSObject | string | number> } => ({
  root: {
    backgroundColor: "#fff",
    minWidth: "15%",
    position: "relative",
  },
  rootLabelDropDown: {
    // backgroundColor: "#fff",
    width: "100%",
    position: "relative",
    justifyContent: "space-between",
  },
  button: {
    width: "100%",
    background: "white",
    borderRadius: "24px",
    height: "40px",
    border: "1px solid #D9D9D9",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "10px 15px",
    cursor: "pointer",
    "&.open": {
      border: "2px solid #000",
    },
  },
  buttonLabelDropDown: {
    width: "100%",
    background: "white",
    borderRadius: "8px",
    height: "40px",
    border: "0px solid #D9D9D9",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "8px 12px",

    cursor: "pointer",
    "&.open": {
      border: "2px solid #000",
    },
  },
  buttonText: {
    fontFamily: "Gilroy-Regular",
    fontSize: "16px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  dropdownMenu: {
    position: "absolute",
    top: "100%",
    left: 0,
    minWidth: "70%",
    marginTop: "10px",
    backgroundColor: "white",
    padding: "14px 24px",
    borderRadius: "5px",
    zIndex: 2,
    boxShadow: "1px 3px 5px rgba(0, 0, 0, 0.29)",
  },
  dropdownMenuLabelDropDown: {
    position: "absolute",
    top: "100%",
    // left: "90%",
    right: 0,
    minWidth: "15%",
    marginTop: "10px",
    backgroundColor: "white",
    padding: "14px 24px",
    borderRadius: "5px",
    zIndex: 2,
    boxShadow: "1px 3px 5px rgba(0, 0, 0, 0.29)",
  },
  label: {
    fontFamily: "Gilroy-Regular",
    fontSize: "16px",
    // border: "2px solid #000",
    padding: "8px 12px",
  },

  dropdownItem: {
    fontFamily: "Gilroy-Regular",
    fontSize: "16px",
    padding: "8px 0",
    cursor: "pointer",
    "&:hover": {
      color: theme.colorSchema.colors.mainText,
    },
  },
});
